/**
 * 일지 캘린더 + 월간통계 + 메모/지출 (구 public/js/m-diary-a.js 이관)
 *
 * 월 달력 렌더(클라이언트 buildCalendarShellHtml) + 날짜별 예약/수주/발주/지출 통계 표시 +
 * 일정/메모/지출 CRUD + 드래그 월이동. 데이터는 /m/ajax/diary/monthly/orders.
 *
 * [점진 이관] 함수는 모듈 스코프 그대로 두고 생성자에서 window 에 일괄 등록한다.
 * 내부 상호호출·PHP 인라인 onclick·m-diary.js 호출이 전부 bare 이름→window 로 해소되어
 * 회귀면적이 작다. 졸업(경로 B) 시 클래스 메서드화. (diary-js-migration.md §3)
 *
 * [공유 가변전역] autoOnceDone/onceSelect/lastCallShowDay/lastTabSeld/
 * start_baseDate/selected_date_ordernumList 는 PHP 인라인·m-diary.js 와 공유 → window.* 접근.
 */
import Util from '../../../Common/Util';

export default class Calendar {
    constructor() {
        if (typeof window.selected_date_ordernumList === 'undefined') window.selected_date_ordernumList = null;
        Object.assign(window, { page_ScrollSetMt, find_last_NodeOf_Order, find_dateOne_toLoad, load_expenses_list, EditexpenseSet, sample_itemListShow, optionSelectOne, option_select_Ul_ListMake, BottomShowOn, hideHalfTd, Show_Days_toEachTD_Misoo, Show_Days_toEachTD, makeTD_BackOn, showDayInfo, DayInfoGetdisplay, askAddReg, showDinfo, goToMemo, get_user_expenseTypeList, chek_dLists, samplePut, listTabMenuset, mySubmitFunction, doItemTitleSet, show_seldDate_memos, add_jobIn, setNoendDate, showExpense_Detail, load_memo_list, showMemosInList, deletedayMemo, check_extypeset, positionCalendarTopBar, buildCalendarShellHtml, year_month_apply, draw_calendar_data, get_firstDay_One, chDate_in, DateChangeToCh, DateChangeTo, monthDataDisplayTo, renderCalendarMonth, min_morefile, initExpenseDatePicker, initYearMonthPicker, openDiaryYmPicker });
    }
}

// 구 암묵전역 baseMatchNode(get_firstDay_One write-only, 비공유) → 모듈 로컬화
let baseMatchNode = null;

// (제거) 달력 스와이프 드래그 전용 전역(CMoveReset/MoveObj/isMoving/drag_pos/TStartTime) +
//        미사용 pageToMove — 관련 터치 핸들러가 이벤트에 바인딩된 적 없어 死코드였음.
var isloadingClick=0;

function page_ScrollSetMt(Obj){
    var RT = Obj.getBoundingClientRect();
}
function find_last_NodeOf_Order(){
    window.autoOnceDone = 9;
    var obj = document.getElementById("DayContentDiv");
    var inputs = obj.getElementsByTagName("DIV");
    for (var i=0; i < inputs.length ; i++ ){
        var one = inputs[i];
        var rsno = parseInt(one.getAttribute("rsno"));
        var istopdiv = parseInt(one.getAttribute("istopdiv"));
        if( rsno == showipicknum && istopdiv == 1){
            var inputsN = one.getElementsByTagName("TR");
            var oneGet = inputsN[1];
            oneGet.click();
        }
    }
}
function find_dateOne_toLoad(autoSelDate){
    var obj = document.getElementById("ccTbody");
    var inputs = obj.getElementsByTagName("TD");
    for (var i=0; i < inputs.length ; i++ ){
        var hd = "TD_" + autoSelDate
        if ( inputs[i].id == hd){
            window.autoOnceDone = 1;
            inputs[i].click();

            break;
        }
    }
}

/**
 * 일별 지출목록
 */
function load_expenses_list(){
    var calender_yearval = document.getElementById("calender_yearval").value;
    var calender_monthval = Util.number_to_withzero(document.getElementById("calender_monthval").value,2);
    var adr = "/m/ajax/diary/expense/day";
    var sendData = {"tar_year":calender_yearval,  "tar_month":calender_monthval ,"tar_day":window.lastCallShowDay, "orders": window.selected_date_ordernumList};
    $.ajax({type:"GET", url:adr , data:sendData , dataType:'json', success:function(data){
            var DT = data.datas;
            var obj = document.getElementById("expenseBody");
            obj.innerHTML = "";
            if( DT.length < 1 ){
                var TR = document.createElement('TR');
                TR.innerHTML = "<td colspan=4 style='text-align:center'>이달에 등록된 지출내역이 없습니다.</td>";
                obj.appendChild(TR);
                document.getElementById("excpenseinputlist_ContDiv").style.display="block";
                return;
            }
            for (var i = 0; i < DT.length; i++ ){
                var chit = DT[i];
                var eano = chit.ex_num;
                var ex_title = chit.ex_title;
                var ex_type = chit.ex_type;
                var date_start = chit.date_start;
                var date_end = chit.date_end;
                var reg_date = chit.reg_date;
                var ex_mount = Util.formatNumber(chit.ex_mount);
                var car_uniqnum = chit.car_plate;
                var main_type = chit.main_type;
                if (ex_type != "3" ) main_type = chit.ex_titsub;
                if (ex_type != "3" ) car_uniqnum = chit.ex_titsub;
                ex_type == "1" ? ex_types = "매달" : ex_types ="한번";
                main_type = Util.escapeHtml(main_type);
                if( ex_type == "3") main_type = "<font style='color:var(--diary-sun)'>" + main_type + "</font>"
                var TR = document.createElement('TR');
                TR.setAttribute("onclick", "showExpense_Detail(" + eano + ")");
                var htms = "<td>" + Util.escapeHtml(ex_title) + "</td><td>" + ex_mount + "</td><td>" + main_type + "</td><td>" + Util.escapeHtml(car_uniqnum) + "</td>";
                var infos = ex_title + "|" + ex_mount + "|" + ex_type + "|" + date_start + "|" + date_end + "|" + chit.ex_titsub;
                TR.innerHTML =htms;
                obj.appendChild(TR);
                TR = document.createElement('TR');
                TR.setAttribute("style", "display:none");
                TR.setAttribute("id", "expenseTR" + eano);
                TR.setAttribute("class", "expenseTRAll");
                htms = "<td colspan=4>";
                htms += "<table style='width:100%; table-layout:fixed; border-collapse:collapse; white-space:nowrap'>";
                if( ex_type == "3"){
                    htms += "	<tr style='background-color:var(--diary-headrow-bg)'>";
                    htms += "		<td style='text-align:center'>작업일</td>";
                    htms += "		<td style='text-align:center'>" + date_start.replace(/-/gi,"/") +"</td>";
                    htms += "		<td style='text-align:center'>등록일</td>";
                    htms += "		<td style='text-align:center;width:130px'>" + reg_date.replace(/-/gi,"/") +"</td>";
                    htms += "	</tr>";
                    //htms += "	<tr><td>~</td><td>" + date_end.replace(/-/gi,"/") +"</td></tr>";
                }else{
                    htms += "	<tr><td>시작일</td><td>" + date_start.replace(/-/gi,"/") +"</td></tr>";
                    htms += "	<tr><td>종료일</td><td>" + date_end.replace(/-/gi,"/") +"</td></tr>";
                    htms += "	<tr datas='" + Util.escapeHtml(infos) +"'>";
                    htms += "		<td colspan=2 style='text-align:center ; height:40px'>";
                    htms += "			<input type='button' value='삭제' onclick='deleteexpenseSet(" + eano + ")' style='width:55px; padding:3px'>";
                    htms += "			<input type='button' value='수정' onclick='EditexpenseSet(" + eano + ", this)' style='width:55px; padding:3px'>";
                    htms += "		</td>";
                    htms += "	</tr>";
                }
                htms += "</table>";
                htms += "</td>";
                TR.innerHTML =htms;
                obj.appendChild(TR);
            }
            //document.getElementById("excpenseinputlist_ContDiv").style.display="none";
        }});
}

/**
 * 지출항목 편집
 * @param no
 * @param tar
 * @constructor
 */
function EditexpenseSet(no, tar){
    var one = tar.parentNode.parentNode;
    var vals = one.getAttribute("datas");
    if( vals == undefined) vals = "";
    no = parseInt(no);
    if( isNaN(no)) no = 0;
    document.getElementById("expenseSaveno").value="0";
    document.getElementById("expenseSaveBtn").innerHTML="등 록";
    if( no == 0 || vals.length < 10 ){alert("수정할 번호가 없습니다."); return; }
    document.getElementById("expenseSaveno").value=no;
    document.getElementById("expenseSaveBtn").innerHTML="수 정";
    vals = vals.split("|");
    var expensetype = parseInt( vals[2]);
    if( isNaN(expensetype)) expensetype = 1;

    document.getElementById("expensetitle").value = vals[0];
    document.getElementById("expensesub").value = vals[5];
    document.getElementById("expenseamount").value = vals[1];
    if(expensetype == 1 ) document.getElementById("expensetypeA").checked=true;
    if(expensetype == 2 ) document.getElementById("expensetypeB").checked=true;
    document.getElementById("expensestart").value = vals[3];
    document.getElementById("expenseend").value =vals[4];
    check_extypeset();
}

function sample_itemListShow(){
    chek_dLists(-1);
    var cont = "";
    var dt = fixed_itemlist.split("|");
    for (var i = 0; i < dt.length; i++ ){
        cont += "<li class='optionListBtn' onclick='optionSelectOne(this)'>" + dt[i] + "</li>";
    }
    option_select_Ul_ListMake(cont, 70);
}
function optionSelectOne(tar){
    var cont = tar.innerHTML;
    document.getElementById("expensetitle").value=cont;
    var obj = document.getElementById("option_select_FlyDiv");
    if( obj ){
        document.body.removeChild(obj);
        return;
    }

    $('#option_select_FlyDiv').hide();
}
function option_select_Ul_ListMake(cont, firstDiv_width){
    var div = document.createElement('div');
    div.setAttribute("style" , "width:100%;height:100%;background:rgba(0,0,0,0.6);position:fixed;left:0px;top:0px;z-index:999999;display:block");
    div.setAttribute("id" , "option_select_FlyDiv");
    var divIn = document.createElement('div');
    divIn.setAttribute("style" , "width:" + firstDiv_width + "%");
    divIn.setAttribute("class" , "optionMainDiv");
    var UL = document.createElement('UL');
    UL.setAttribute("style" , "list-style: none; padding:10px 0px 10px 0px ; width:80% ; margin:0px auto; height:300px; overflow-x:hidden; overflow-y:auto");
    UL.innerHTML = cont;
    divIn.appendChild(UL);
    var divBtn = document.createElement('div');
    divBtn.setAttribute("style" , "width:100%;text-align:center; margin-bottom:10px; margin-top:10px");
    divBtn.innerHTML = "<button type='button' class='optonBtn' style='width:70px; height:25px;' onclick=\"$('#option_select_FlyDiv').hide()\">취소</button>";
    divIn.appendChild(divBtn);
    div.appendChild(divIn);
    document.body.appendChild(div);
}

function BottomShowOn(n){
    var obj = document.getElementById("bottomInofTable");
    var nn = parseInt(obj.style.height);
    if( nn > 70 ){
        obj.style.height="20px";
    }else{
        obj.style.height="80px";
    }

}
function hideHalfTd(n){
    var obj = document.getElementById("ccTbody");
    var inputs = obj.getElementsByTagName("DIV");
    for (var i = 0; i < 6; i++ ){
        var ea = document.getElementById("infoTake_" + i);
        if( ea ) ea.style.display="none";
    }
    for (var i=0; i < inputs.length ; i++ ){
        if ( inputs[i].className == "tdInsideDiv"){
            var tar = inputs[i];
            var subs = tar.childNodes;
            var nt = "12px";
            var dt = "none";
            if( n > 0 ) {
                nt = "auto";
                dt = "block";
            }
            tar.style.height=nt;
            tar.style.minHeight=nt;
            $("#" + tar.id).animate( { height:nt });
            subs[1].style.display=dt;
            subs[2].style.display=dt;
            subs[3].style.display=dt;
        }
    }
}
var month_incomeList = {};
function Show_Days_toEachTD_Misoo(){
    var obj = document.getElementById("ccTbody");
    var inputs = obj.getElementsByTagName("DIV");
    var calender_yearval = document.getElementById("calender_yearval").value;
    var calender_monthval = Util.number_to_withzero(document.getElementById("calender_monthval").value,2);
    var thisYM = calender_yearval + "-" + calender_monthval;
    var baseMatchNode = null;
    console.log("미수만 보기 중");
    var Bal_misoo = 0;
    var Soo_misoo = 0;
    var a1 = 0, a2 = 0 , a3 = 0 , a4 = 0;
    var Picon = "<img src='/img/point_cir_img.svg' style='width:10px;position:relative;top:1px'>";
    Picon = "";
    for (var i=0; i < inputs.length ; i++ ){
        if ( inputs[i].className == "tdInsideDiv"){
            var tar = inputs[i];
            var eaid = inputs[i].id;
            if( eaid == undefined) eaid = "";
            var chit = day_Values[eaid];
            //console.log( chit);
            var eaidSoo = eaid + "_CM";
            var TarSoo = document.getElementById(eaidSoo);
            if( eaid == window.start_baseDate) baseMatchNode = inputs[i];
            if( chit){
                tar.style.display = "none";
                TarSoo.innerHTML = "";
                TarSoo.style.display = "block";
                var cont = "";
                if( dir_Showmode == 2 ){
                    var BalNotPayed = Util.int(chit.BalNotPayed);
                    var ineedtoGet = Util.int(chit.ineedtoGet);
                    if( BalNotPayed > 0 || ineedtoGet > 0 ){
                        if( BalNotPayed > 0 || ineedtoGet > 0  ){
                            var chx = "OK";
                            if( eaid.indexOf(thisYM) >= 0 ){
                                a1 = parseInt( a1 + chit.SooNot);
                                a2 = parseInt( a2 + chit.SooOK);
                                a3 = parseInt( a3 + chit.ineedtoGet);
                                a4 = parseInt( a4 + chit.ialreadyGot);
                                console.log( eaid + " / " + thisYM);
                            }else{
                                chx = "blk";
                            }

                            cont+="<div class='memoCirdiv gray' style='position: relative;vertical-align: top;top: -21px;color:var(--diary-ink);margin-right:2px'>" + parseInt( chit.Soo) + "</div>";
                            cont+="<div class='inDivA " + chx + "' data-type='OK' id='inDiv1'><span class='inSpanA AA'>미수</span><span class='inSpanAT bd'>" + chit.SooNot + "</span></div>";
                            cont+="<div class='inDivA " + chx + "' data-type='OK' id='inDiv1'><div class='inSpanAX'>" + Picon + Util.formatNumber(chit.ineedtoGet) + "</div></div>";
                            cont+="<div class='inDivA " + chx + "' data-type='OK' id='inDiv1'><span class='inSpanA BB'>수금</span><span class='inSpanAT bd'>" + chit.SooOK + "</span></div>";
                            cont+="<div class='inDivA " + chx + "' data-type='OK' id='inDiv1'><div class='inSpanAX'>" + Picon + Util.formatNumber(chit.ialreadyGot) + "</div></div>";
                            cont+="<div class='inDivA " + chx + "' data-type='OK' id='inDiv1'><span class='inSpanA CC'>발행</span><span class='inSpanAT'>" + chit.taxbill_out_tot + "</span></div>";


                        }
                        TarSoo.innerHTML = cont;
                    }
                }else{
                    var Bal = Util.int(chit.Balsign);
                    var cont = "";
                    if( Bal > 0 ){
                        var chx = "OK";
                        if( eaid.indexOf(thisYM) >= 0 ){
                            a1 = parseInt( a1 + chit.Balsign_no);
                            a2 = parseInt( a2 + chit.Balsign_ok);
                            a3 = parseInt( a3 + chit.ineedtoPay);
                            a4 = parseInt( a4 + chit.ialreadyPay);
                        }else{
                            chx = "blk";
                        }

                        cont+="<div class='inDivA " + chx + "' data-type='OK' id='inDiv1'><span class='inSpanA AA' style='letter-spacing:0px'>미지급</span><span class='inSpanAT bd'>" + chit.Balsign_no + "</span></div>";
                        cont+="<div class='inDivA " + chx + "' data-type='OK' id='inDiv1'><div class='inSpanAX'>" + Util.formatNumber(chit.ineedtoPay) + "</div></div>";
                        cont+="<div class='inDivA " + chx + "' data-type='OK' id='inDiv1'><span class='inSpanA BB' style='letter-spacing:-1px;padding:0px 2px'>&nbsp;지 급&nbsp;</span><span class='inSpanAT bd'>" + chit.Balsign_ok + "</span></div>";
                        cont+="<div class='inDivA " + chx + "' data-type='OK' id='inDiv1'><div class='inSpanAX'>" + Picon + Util.formatNumber(chit.ialreadyPay) + "</div></div>";
                        cont+="<div class='inDivA " + chx + "' data-type='OK' id='inDiv1'><span class='inSpanA CC' style='letter-spacing:-1px;padding:0px 2px'>&nbsp;수 신&nbsp;</span><span class='inSpanAT'>" + chit.taxbill_in_tot  + "</span></div>";

                    }
                    TarSoo.innerHTML = cont;
                }
            }
        }
    }
    if( isMobile || G5['isDebug']){
        //document.getElementById("bottomInofTable").style.height="52px";

        document.getElementById("TTIT1").innerHTML = "미수건수";
        document.getElementById("TTIT2").innerHTML = "미수금액";
        document.getElementById("TTIT3").innerHTML = "수금건수";
        document.getElementById("TTIT4").innerHTML = "수금금액";
        document.getElementById("TTIT5").innerHTML = "미수 총건수";
        document.getElementById("TTIT6").innerHTML = "미수 총금액";

        if( dir_Showmode == 3 ){
            document.getElementById("TTIT1").innerHTML = "미지급 건수";
            document.getElementById("TTIT2").innerHTML = "미지급 금액";
            document.getElementById("TTIT3").innerHTML = "지급 건수";
            document.getElementById("TTIT4").innerHTML = "지금 금액";
            document.getElementById("TTIT5").innerHTML = "지급 총 건수";
            document.getElementById("TTIT6").innerHTML = "지급 총금액";
        }

        console.log("dir_Showmode:" + dir_Showmode);

        document.getElementById("binfotd1").innerHTML = Util.formatNumber(a1) + "건"; // 미수건
        document.getElementById("binfotd2").innerHTML = Util.formatNumber(a3) + "원"; //미수금액
        document.getElementById("binfotd3").innerHTML = Util.formatNumber(a2) + "건"; //수금건
        document.getElementById("binfotd4").innerHTML = Util.formatNumber(a4) + "원"; //수금금액
        document.getElementById("binfotd5").innerHTML = Util.formatNumber(parseInt(a1+a2)) + "건"; //수금받을 총건
        document.getElementById("binfotd6").innerHTML = Util.formatNumber(parseInt(a3+a4)) + "원"; //수금받을 총금액



    }else{
        document.getElementById("binfotd2").innerHTML = "모바일에서만보입니다.";
    }
    if( baseMatchNode != null){
        if( window.onceSelect == 0 && window.lastCallShowDay == ""){
            window.onceSelect = 9;
            var tar = baseMatchNode.parentNode;
            tar.click();
        }
    }
}

/**
 * 달력 칸에 수,발,예 등의 데이터를 표시한다.
 * @constructor
 */
function Show_Days_toEachTD(){
    if( dir_Showmode == 2 ){ Show_Days_toEachTD_Misoo(); return; }
    if( dir_Showmode == 3 ){ Show_Days_toEachTD_Misoo(); return; }

    var obj = document.getElementById("ccTbody");
    var inputs = obj.getElementsByTagName("DIV");
    var Total = 0;
    var ialreadyGot = 0;
    var ialreadyPay = 0;
    var ineedtoGet = 0;
    var ineedtoPay = 0;
    var expenses = 0;
    var TotalBal = 0;
    var BalgetPayed = 0;
    var calender_yearval = document.getElementById("calender_yearval").value;
    var calender_monthval = Util.number_to_withzero(document.getElementById("calender_monthval").value,2);
    var thisYM = calender_yearval + "-" + calender_monthval;
    var baseMatchNode = null;
    var Picon = "<img src='/img/point_cir_img.svg' style='width:10px;position:relative;top:1px'>";
    Picon = "";
    for (var i=0; i < inputs.length ; i++ ){
        if ( inputs[i].className == "tdInsideDiv"){
            var tar = inputs[i];
            var eaid = inputs[i].id;
            if( eaid == undefined) eaid = "";
            var chit = day_Values[eaid];
            var daymemo = parseInt(memo_cntList[eaid]);
            if( isNaN(daymemo)) daymemo = 0;
            var ttObj = tar.parentNode;
            var inputsP = ttObj.getElementsByTagName("SPAN");
            var oneP = null;


            if( inputsP.length > 0 ) oneP = inputsP[0];
            if( oneP){
                if( daymemo > 0 ){
                    oneP.style.display="inline-block";
                    oneP.innerHTML = daymemo;
                }else{
                    oneP.style.display="none";
                    oneP.innerHTML = "";
                }
            }
            if( eaid == window.start_baseDate) baseMatchNode = inputs[i];
            if( chit){
                tar.style.visibility = "visible";
                var subs = tar.childNodes;
                var soo = chit.Soo;
                var bal = chit.Bal;
                var TotalBal_yet = chit.TotalBal_yet;
                var Soo_yet = chit.Soo_yet;
                var reserv = chit.Reserv;
                var expense = chit.expenses;

                if( eaid.indexOf(thisYM) >= 0 ){
                    var mms = eaid.split("-");
                    var mid = eaid.replace(/-/gi,"");
                    if( typeof(month_incomeList[mid]) != "object") month_incomeList[mid] = {"date":mms, "price":0};
                    Total = parseInt( Total + chit.Total);
                    TotalBal = parseInt( TotalBal + chit.TotalBal);
                    BalgetPayed = parseInt( BalgetPayed + chit.BalgetPayed);
                    ialreadyGot = parseInt( ialreadyGot + chit.ialreadyGot);
                    ialreadyPay = parseInt( ialreadyPay + chit.ialreadyPay);
                    ineedtoGet = parseInt( ineedtoGet + chit.ineedtoGet);
                    ineedtoPay = parseInt( ineedtoPay + chit.ineedtoPay);
                    if( chit.ialreadyPay > 0 ){
                        console.log( chit);
                    }
                    expenses = parseInt( expenses + chit.expenses);
                }else{
                }
                subs[0].childNodes[1].innerHTML = "<font style='color:var(--diary-link)'>" + reserv + "</font>";
                reserv > 0  ? subs[0].childNodes[1].style.color="var(--diary-sun)" : subs[0].childNodes[1].style.color="var(--diary-ink)"  ;
                reserv > 0  ? subs[0].childNodes[1].style.fontWeight="bolder" : subs[0].childNodes[1].style.fontWeight="normal";
                if( reserv < 1 ){
                    // subs[0].style.display="none";
                    // subs[0].style.visibility = "hidden" ;
                    subs[0].innerHTML='';
                }else{
                    subs[0].style.display="block";
                    subs[0].style.visibility = "visible";
                }
                var sooMg = soo;
                var balMg = bal;
                sooMg = "<font style='color:var(--diary-link)' das='" + chit.Soonums + "'>" + parseInt( Soo_yet) + "/<font style='color:var(--diary-ink)'>" + parseInt(soo-Soo_yet) + "</font>";
                balMg =  "<font style='color:var(--diary-link)'>" + parseInt(TotalBal_yet) + "/<font style='color:var(--diary-link)'>" + parseInt(bal - TotalBal_yet)  + "</font>";
                subs[1].childNodes[1].innerHTML =  sooMg ;  // 수주    Soo_yet
                subs[2].childNodes[1].innerHTML = balMg;   // 발주
                if( bal > 0 ){
                    var valYet = chit.TotalBal_yet;
                }
                subs[1].childNodes[1].style.color="var(--diary-ink)";
                subs[2].childNodes[1].style.color="var(--diary-ink)";
                subs[1].childNodes[1].style.fontWeight="normal";
                subs[2].childNodes[1].style.fontWeight="normal";
                if( soo > 0 ){
                    subs[1].childNodes[1].style.color="var(--diary-sun)";
                    subs[1].childNodes[1].style.fontWeight="bolder";
                }
                if( bal > 0 ){
                    subs[2].childNodes[1].style.color="var(--diary-sun)";
                    subs[2].childNodes[1].style.fontWeight="bolder";
                }
                soo < 1 ? subs[1].style.visibility = "hidden" : subs[1].style.visibility = "visible";
                bal < 1 ? subs[2].style.visibility = "hidden" : subs[2].style.visibility = "visible";

                if( expense > 0 ){
                    subs[3].style.visibility = "visible"
                    subs[3].childNodes[1].innerHTML = "" + Picon +  Util.formatNumber(expense);
                }else{
                    subs[3].style.visibility = "hidden"
                    subs[3].childNodes[1].innerHTML = "";
                }

            }
        }
    }
    var bal_s = parseInt( parseInt(TotalBal - BalgetPayed) ); //+ parseInt(ineedtoPay));
    var T_in = parseInt(Total - expenses);
    var nns = 10000;
    if( isMobile || G5['isDebug']){
        document.getElementById("binfotd1").innerHTML = Util.formatNumber(Total);
        document.getElementById("binfotd2").innerHTML = Util.formatNumber(expenses);
        document.getElementById("binfotd3").innerHTML = Util.formatNumber(ineedtoGet) ;
        document.getElementById("binfotd4").innerHTML = Util.formatNumber(T_in);
        document.getElementById("binfotd5").innerHTML = Util.formatNumber(ineedtoPay)
        document.getElementById("binfotd6").innerHTML = Util.formatNumber(ialreadyPay) ;
    }else{
        document.getElementById("binfotd2").innerHTML = "모바일에서만보입니다.";
    }
    var myIn = parseInt( Total - ialreadyPay);

    if( baseMatchNode != null){
        if( window.onceSelect == 0 && window.lastCallShowDay == ""){
            window.onceSelect = 9;
            var tar = baseMatchNode.parentNode;
            tar.click();
        }
    }
}
function makeTD_BackOn(tar, subact){
    if( subact == undefined) subact = "";
    var obj = document.getElementById("ccTbody");
    var inputs = obj.getElementsByTagName("TD");
    for (var i=0; i < inputs.length ; i++ ){
        if( inputs[i].getAttribute("data-type") == "titleTD"){
            if( tar == null || window.onceSelect == 9 || subact == "keepsel"){
                inputs[i].style.opacity="1";
            }else{
                inputs[i].style.opacity="0.3";
            }
            if ( inputs[i].id == tar){
                inputs[i].style.backgroundColor="var(--diary-cell-today)";//EAF4FF /// #FFC2A6 A4FFA4
                inputs[i].style.opacity="1";
            }else{
                inputs[i].style.backgroundColor="var(--diary-surface)";
            }
        }
    }
    window.onceSelect = 1;
}

function showDayInfo(dDay, rown, tarTD){
    if( dDay == undefined) dDay = "";
    //document.getElementById("addbottonBtnDiv").style.display="none";
    if( dDay.length < 10 ) return;
    for (var i = 0; i < 6; i++ ){
        var ea = document.getElementById("infoTake_" + i);
        if( ea ) ea.childNodes[0].innerHTML = "";
    }
    if( window.onceSelect == 9 ){
        window.lastCallShowDay = dDay;
        makeTD_BackOn(tarTD.id);
        document.getElementById("pagegabheight").style.display="none";
        return;
    }
    window.onceSelect = 1;
    var obj = document.getElementById("infoTake_" + rown);
    if( ! obj) return;
    lastDownRowNum = rown;

    if( parent.calenderBoxCalled){
        window.parent.calenderBoxCalled(dDay);
        return;
    }
    if( obj.style.display=="table-row" && window.lastCallShowDay == dDay){
        obj.childNodes[0].innerHTML = "";
        obj.style.display="none";
        makeTD_BackOn(tarTD.id ,"keepsel");
        document.getElementById("addbottonBtnDiv").style.display="block";
        document.getElementById("pagegabheight").style.display="none";
        return;
    }
    makeTD_BackOn(tarTD.id);

    for (var i = 0; i < 6; i++ ){
        var ea = document.getElementById("infoTake_" + i);
        if( ea ) ea.style.display="none";
    }
    window.lastCallShowDay = dDay;
    reset_processArray();
    obj.childNodes[0].innerHTML = dDay + " 자료 불러오는중";
    obj.style.display="table-row";
    // JSON+JS 렌더: 서버(DiaryController@dayOrders)에서 카드 데이터(rows)만 받아 클라이언트가 DOM 을 만든다.
    $.getJSON("/m/ajax/diary/day-orders", {
        pickday: dDay,
        showmode: dir_Showmode,
    }).done(function (res) {
        DayInfoGetdisplay(window.$j.F.DiaryList.renderDay(res));
    }).fail(function () {
        DayInfoGetdisplay("");
    });
}

window.selected_date_ordernumList = null;
var lastDownRowNum = 0;
function DayInfoGetdisplay(data){
    var obj = document.getElementById("infoTake_" + lastDownRowNum);

    document.getElementById("addbottonBtnDiv").style.display="none";
    var inss = '<div style="width:100%;overflow-x:hidden" id="mginsideloading">';
    inss += "<div class='mTabHolder'>";
    inss += "<div class='mTabone a on' onclick='listTabMenuset(1)' id='mmTabs1'>일지내역</div>";
    inss += "<div class='mTabone a' onclick='listTabMenuset(2)' id='mmTabs2'>일정</div>";
    inss += "<div class='mTabone b' onclick='listTabMenuset(3)' id='mmTabs3'>지출</div>";
    inss += "</div>";
    inss += "<div style='width:100%; margin-top:5px' id='DayContentDiv'>";


    if( data.indexOf("showDetailTable") > 0 ){
        var moreAdd = "";

        var moreAdd = "<div style='width:99.5%; margin:0px auto; text-align:center;font-size:15px; line-height:25px; border:1px solid var(--diary-border); background-color:var(--diary-chip-bg); color:var(--diary-ink-fixed);vertical-align:top;position:relative;top:-4px' onclick='askAddReg()'>일지 추가등록</div>";
        moreAdd += "<div style='width:100%;' id='eaDayOdList'></div><div style='width:100%;height:150px'></div>";
        obj.childNodes[0].innerHTML = inss + data + "</div>" +  memo_expenSeHtml + "</div>" + moreAdd;
        document.getElementById("pagegabheight").style.display="none";
        if(document.getElementById("orderListNums")){
            window.selected_date_ordernumList = document.getElementById("orderListNums").innerHTML;
        }else{
            window.selected_date_ordernumList = "";
        }
        // 진행바 추적목록은 ProgressBar.js 가 DOM(data_cd)에서 직접 수집한다 — 여기서 이 날짜 컨테이너를
        // 루트로 넘겨 시작(구 수동 re_Make 루프 제거).
        window.$j.F.Diary.ProgressBar.start(obj);
    }else{
        //console.log( "mbno:" + mbno );
        window.selected_date_ordernumList = "";
        var nodata = "<div style='width:100%; text-align:center; font-size:15px; line-height:25px; margin-bottom:30px'>";
        nodata += "<Br>" + window.lastCallShowDay + "<br>일지없음<br><br>";
        nodata += "<a href='javascript:add_jobIn(this)'><img src='/img/add_btn_circle_101.png' style='width:50px' class='ImgBtn'><br>일지등록</a>";
        nodata += "</div>";
        nodata = diary_RegnewTypeSelBtns();
        obj.childNodes[0].innerHTML = inss + nodata + "</div>" + memo_expenSeHtml + "</div>";
        document.getElementById("pagegabheight").style.display="none";
        document.getElementById("addbottonBtnDiv").style.display="none";
        //if( mbno == 10 ) regMyWork(1);
    }
    if( typeof initExpenseDatePicker === "function" ) initExpenseDatePicker(); // 지출 달력 재바인딩(memo_expenSeHtml 재주입 직후)
    //document.getElementById("addbottonBtnDiv").style.display="none";
    if( window.autoOnceDone == 1 && autoSelDate.length ==10 ){
        listTabMenuset(1);
    }else{
        listTabMenuset(window.lastTabSeld);
    }
}
function askAddReg(){
    var nodata = diary_RegnewTypeSelBtns();
    var obj = document.getElementById("eaDayOdList");
    obj.innerHTML = nodata;

}

function showDinfo(dval){ // showDinfo("2019-10-29");
    var ch = day_Values[dval];
    console.log( dval );
    console.log( ch );
}
function goToMemo(){
    if( window.lastCallShowDay == undefined) window.lastCallShowDay = "";
    //hideHalfTd(-1);
    //document.getElementById("memoRegTt").innerHTML = window.lastCallShowDay + " " ;
    //document.getElementById("addbottonBtnDiv").style.display="none";
    //show_seldDate_memos();
}

var user_expenseTypeList = null;
function get_user_expenseTypeList(){
    var adr = "/m/ajax/diary/expense/types";
    $.ajax({type:"GET", url:adr , dataType:'json', success:function(data){
            user_expenseTypeList = data;
        }});
}
function chek_dLists(tar){
    var obj = document.getElementById("exmylistshow");
    if( tar == -1) {
        obj.style.display="none";
        return;
    }
    if( typeof(user_expenseTypeList) != "object") user_expenseTypeList = [];
    var RT = tar.parentNode.getBoundingClientRect();
    obj.style.display="block";
    obj.style.width=parseInt(RT.width -25 ) + "px";
    obj.style.top=parseInt(RT.y+ RT.height) + "px";
    obj.style.left=parseInt(RT.x + 5 )  + "px";
    var ret = "";
    for (var i = 0; i < user_expenseTypeList.length;i++ ){
        var chit = user_expenseTypeList[i];
        var tit = chit[0]; var ess = chit[1];
        ret += "<div class='sampleLine' data_a='"+ tit + "' data_b='"+ ess + "' onclick='samplePut(this)'>"+ tit + "(" + ess + ")</div>";
    }
    ret+="<div class='sampleLine' onclick='sample_itemListShow()' style='color:var(--diary-link); font-weight:bolder'>예제항목</div>";
    ret+="<div class='sampleLine' onclick='chek_dLists(-1)' style='color:var(--diary-sun); font-weight:bolder'>닫기</div>";
    obj.innerHTML = ret;
}
function samplePut(tar){
    var a1 = tar.getAttribute("data_a");
    var a2 = tar.getAttribute("data_b");
    document.getElementById("expensetitle").value=a1;
    document.getElementById("expensesub").value=a2;
    chek_dLists(-1);
}
function listTabMenuset(n){
    var mlist = document.getElementById("DayContentDiv");
    var memos = document.getElementById("memoWriteHolder");
    var expens = document.getElementById("excpenseinputlist");
    document.getElementById("mmTabs1").className = "mTabone a";
    document.getElementById("mmTabs2").className = "mTabone a";
    document.getElementById("mmTabs3").className = "mTabone b";
    window.lastTabSeld = n;
    if( n == 1 ){
        mlist.style.display="block";
        memos.style.display="none";
        expens.style.display="none";
        document.getElementById("mmTabs1").className = "mTabone a on";
        if( window.autoOnceDone == 1 && autoSelDate.length ==10 && parseInt(showipicknum) > 0 ){
            find_last_NodeOf_Order();
        }

    }else if( n == 2 ){
        mlist.style.display="none";
        memos.style.display="block";
        expens.style.display="none";
        document.getElementById("memoWriteHolder_box").style.display="block";

        document.getElementById("mmTabs2").className = "mTabone a on";
        load_memo_list(window.lastCallShowDay);
        document.getElementById("DayContentDiv").style.display="none";
        mlist.style.display="none";
    }else if (n == 3){
        mlist.style.display="none";
        memos.style.display="none";
        expens.style.display="block";
        document.getElementById("mmTabs3").className = "mTabone b on";
        document.getElementById("expensestart").value = window.lastCallShowDay;
        document.getElementById("expenseend").value = window.lastCallShowDay;
        document.getElementById("expenseSaveno").value="0";
        document.getElementById("expenseSaveBtn").innerHTML="등 록";
        check_extypeset();
        window.load_expenses_list();  // 중복정의 — 원본 로드순서상 Main(구 m-diary.js) 버전이 win 이므로 window 명시

        if( user_expenseTypeList == null) get_user_expenseTypeList();
    }

}
function mySubmitFunction(evt){
    return false;
}
function doItemTitleSet(tar){
    return false;
}
function show_seldDate_memos(){
}

/**
 * 일지 등록 버튼 눌렀을때
 * @param tar
 */
function add_jobIn(tar){
    if( window.lastCallShowDay == undefined) window.lastCallShowDay = "";
    if( window.lastCallShowDay.length != 10 ){
        document.location.href='/m/bal';
        return;
    }
    var obj = document.getElementById("DayContentDiv");
    var obj2 = document.getElementById("memoWriteHolder");
    var obj3 = document.getElementById("excpenseinputlist");

    if( tar && obj){
        if( obj.style.display=="block"){
            tar.src="/img/add_btn_circle_100_over1.png";
            var obj = document.getElementById("PageMoveLoading");
            obj.style.display="block";
            // 로딩 표시가 그려진 뒤 이동. 예전엔 GIF preload 의 onload 를 기다렸으나
            // 지금은 CSS 인디케이터(.jb-spin)라 rAF 두 번으로 첫 페인트를 기다린다.
            requestAnimationFrame(function(){
                requestAnimationFrame(function(){
                    document.location.href = "/m/bal?picdate=" + window.lastCallShowDay;
                });
            });
        }else if(obj2.style.display=="block"){
            document.getElementById("memoWriteHolder_box").style.display="block";
        }else if(obj3.style.display=="block"){
            document.getElementById("excpenseinputlist_ContDiv").style.display="block";
        }
    }else{
        var adr = "/m/bal?picdate=" + window.lastCallShowDay;
        document.location.href=adr;
    }
}
var uploadImageInputNum = 0;




function setNoendDate(){
    document.getElementById("expenseend").value="2050-12-30";
}
function showExpense_Detail(n){
    $(".expenseTRAll").hide();
    var obj = document.getElementById("expenseTR" + n);
    obj.style.display="table-row";
}
var lastCallMemoDay = "";
// var memo_day_list = {};
function load_memo_list(dDay){
    lastCallMemoDay = dDay;
    // var ch = memo_day_list[dDay];
    // if( ch ){
    //     showMemosInList(ch);
    //     return;
    // }
    var adr = "/m/ajax/daily/memo/list";
    var sendData = {"jobtype":"daymemo_getonly", "dayval":dDay};
    $.ajax({type:"POST", url:adr , data:sendData , dataType:'json', success:function(data){
            // memo_day_list[dDay] = data.datas;
            showMemosInList(data.datas);
        }});
}

/**
 * 일별 메모 출력
 * @param memos
 */
function showMemosInList(memos){
    // console.log(memos);
    if( memos == undefined) memos = [];
    let ret='';
    $.each(memos, function(idx,chit){
        var dnum = chit.num;
        var cont = chit.memocont ;
        // cont = cont.replace(/(?:\r\n|\r|\n)/g, '<br />');
        cont = Util.nl2br(Util.escapeHtml(cont));
        ret += `
        <div class='memoLineDiv'>
            ${cont}
            <div class='memoLineDate'>${Util.getSimpleDateTime(chit.reg_date)} 
                <span style='padding-left:10px' onclick='deletedayMemo(this)' data-value="${dnum}">${Util.escapeHtml(chit.mem_name)} <img src='/img/dlelete.png' style='height:15px'></span>
            </div>
        </div>`;
    });
    $('#seldMemoListDiv').html(ret);
    if( memos.length > 0 ){
        //document.getElementById("memoWriteHolder_box").style.display="none";
    }else{
        document.getElementById("memoWriteHolder_box").style.display="block";
    }
    document.getElementById("memoWriteHolder_box").style.display="block";
}

/**
 * 일별 메모 삭제
 * @param el
 */
function deletedayMemo(el){
    Util.swalert(["해당 일정을 삭제 할까요?",'question'],()=>{
        const num = $(el).attr('data-value');
        const adr = "/m/ajax/daily/memo";
        const sendData = {"num":num};
        $.ajax({type:"delete", url:adr , data:sendData , dataType:'json',success:function(data){
                if(data.rows>0) {
                    $(el).parent().parent().remove();
                }
            }});
    },['확인','아니오']);
}

function check_extypeset(){
    var yy = document.getElementById("calender_yearval").value;
    var mm = Util.number_to_withzero(document.getElementById("calender_monthval").value,2);
    var thisM = yy + "-"  + mm + "-02";
    if( document.getElementById("expensetypeB").checked==true ){
        document.getElementById("dateTitlebTR").style.display="none";
        document.getElementById("dateTitlea").innerHTML = "지출일자";
        document.getElementById("expensestart").value = window.lastCallShowDay;
        document.getElementById("expenseend").value = window.lastCallShowDay;
    }else if(document.getElementById("expensetypeA").checked==true ){
        if( document.getElementById("expensestart").value.length < 10 ){
            document.getElementById("expensestart").value = thisM;
        }
        document.getElementById("dateTitlea").innerHTML = "지출시작";
        document.getElementById("expenseend").value = "2030-12-25";
        document.getElementById("dateTitlebTR").style.display="table-row";
        if( document.getElementById("expenseend").value.length < 10 ){
        }
    }
}
// 상단 네비바 — 구 initPgSelf 는 화살표/년월박스 높이를 재서 top 을 계산해 세로중앙을 맞추고
// visibility:hidden 을 풀어주는 JS 해킹이었다. 상단바를 flex(align-items:center)로 바꾸면서
// 위치보정이 불필요해졌고, 마크업에서 visibility:hidden 도 제거했다.
// 호출부(calendar.blade)와 window 노출을 유지하기 위해 함수 자체는 남겨 no-op 으로 둔다.
function positionCalendarTopBar(){ /* flex 정렬로 대체됨 */ }

// (제거) 달력 스와이프 드래그 서브시스템: touchCheck/check_if_PosV/divPostVToiZero/
//        touchMoceJob/divPostZero (+ PosV_repos). 터치 이벤트에 바인딩된 적이 없는 死코드였음.

// 년월 선택은 Mobiscroll(#diaryYmPicker → openDiaryYmPicker)로 대체됨.
// 구 showMonYBox / year_oneSelect / month_oneSelect (커스텀 오버레이 조작) 제거.

// 지출 시작/종료일 Mobiscroll 달력 바인딩. 지출폼은 memoExpenseTopDiv 재주입마다 재생성되므로
// 주입 직후(load_expenses_list 등) 호출된다. (구 calendar.blade 인라인 <script> 이관)
function initExpenseDatePicker(){
    if( typeof $ === 'undefined' || typeof mobiscroll === 'undefined' ) return;
    ['expensestart','expenseend'].forEach(function(id){
        var el = document.getElementById(id);
        if( !el ) return;
        var $el = $(el);
        $el.mobiscroll('destroy');
        var inst = $el.mobiscroll().datepicker({
            controls: ['calendar'],
            dateFormat: 'YYYY-MM-DD',
            locale: mobiscroll.localeKo,
            buttons: []
        }).mobiscroll('getInst');
        $el.off('click.expdate').on('click.expdate', function(){
            var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(this.value);
            if( m ) inst.setVal(new Date(+m[1], +m[2]-1, +m[3]), true);
            $el.mobiscroll('open');
        });
    });
}

// 상단 년월 선택 Mobiscroll 피커 (구 커스텀 오버레이 #YearMonthSelcter 대체).
// 모바일: 하단 바텀시트 / PC: 클릭한 트리거 위치에 앵커 드롭다운. (구 calendar.blade 인라인 <script> 이관)
function initYearMonthPicker(){
    if( typeof $ === 'undefined' || typeof mobiscroll === 'undefined' ) return;
    var el = document.getElementById('diaryYmPicker');
    if( !el ) return;
    var $el = $(el);
    $el.mobiscroll('destroy');
    window.diaryYmInst = $el.mobiscroll().datepicker({
        controls: ['date'],
        dateWheels: '|YYYY|MM|',
        dateFormat: 'YYYY-MM',
        locale: mobiscroll.localeKo,
        display: isMobile ? 'bottom' : 'anchored',
        touchUi: isMobile,
        // 값 확정 이벤트는 onChange 다. onSet 은 mobiscroll v4 이벤트로 v5(5.35)에는 픽커 레벨에
        // 존재하지 않아 콜백이 아예 호출되지 않는다(= 월을 골라도 무반응). 스크롤 중 변화는 onTempChange.
        onChange: function(ev){
            var d = ev.value;
            if( !d ) return;
            // returnFormat 기본은 jsdate 지만, 문자열(YYYY-MM)로 오는 경우도 방어한다.
            if( typeof d === 'string' ){
                var s = /^(\d{4})-(\d{1,2})/.exec(d);
                if( s ) applyDiaryYm(parseInt(s[1]), parseInt(s[2]));
                return;
            }
            applyDiaryYm(d.getFullYear(), d.getMonth() + 1);
        }
    }).mobiscroll('getInst');
}
// openDiaryYmPicker 의 setVal 도 onChange 를 태우므로, 현재 년월과 같으면 재렌더를 건너뛴다.
function applyDiaryYm(yy, mm){
    var curY = parseInt(document.getElementById('calender_yearval').value);
    var curM = parseInt(document.getElementById('calender_monthval').value);
    if( yy === curY && mm === curM ) return;
    DateChangeTo(yy, mm);
}
function openDiaryYmPicker(anchorEl){
    if( !window.diaryYmInst ) initYearMonthPicker();
    if( !window.diaryYmInst ) return;
    // PC 앵커 모드: 클릭한 요소 위치에 피커 표시
    if( !isMobile && anchorEl ) window.diaryYmInst.setOptions({ anchor: anchorEl });
    var y = parseInt(document.getElementById('calender_yearval').value);
    var m = parseInt(document.getElementById('calender_monthval').value);
    if( !isNaN(y) && !isNaN(m) ) window.diaryYmInst.setVal(new Date(y, m - 1, 1));
    window.diaryYmInst.open();
}

var OnceLoad = 0;

/**
 * 달력 껍데기(빈 격자) HTML 생성. 구 public/_sky_m_05_frame_ajax.php 의 클라이언트 포팅.
 * DB 무관 순수 날짜연산이라 서버왕복이 필요없다. 기존 DOM 계약(id/class/구조)을 1:1 유지하여
 * 2차 데이터 채움 로직(draw_calendar_data / Show_Days_toEachTD 등)이 그대로 동작한다.
 * @param {number} year
 * @param {number} month  1~12
 * @param {number} diaryshowType
 * @returns {string} #cMainHolder 에 주입할 HTML (하단 hidden input 포함)
 */
function buildCalendarShellHtml(year, month, diaryshowType){
    var doms = ["일","월","화","수","목","금","토"];
    var pad2 = function(n){ n = String(n); return n.length < 2 ? "0" + n : n; };
    var today = new Date();
    var todayC = today.getFullYear() + "-" + pad2(today.getMonth()+1) + "-" + pad2(today.getDate());

    var days     = new Date(year, month, 0).getDate();      // 이번달 일수
    var startDay = new Date(year, month-1, 1).getDay();      // 1일의 요일 (0=일)
    var prevYear  = (month == 1)  ? (year - 1) : year;
    var prevMonth = (month == 1)  ? 12 : (month - 1);
    var nextYear  = (month == 12) ? (year + 1) : year;
    var nextMonth = (month == 12) ? 1 : (month + 1);
    var setRows   = Math.ceil((startDay + days) / 7);

    var prevLast = new Date(year, month-1, 0);              // 전달 마지막날
    var PY = prevLast.getFullYear();
    var PM = pad2(prevLast.getMonth() + 1);
    var PD = prevLast.getDate();
    var NY = nextYear;
    var NM = pad2(nextMonth);

    function getFFF(yoil){
        if(yoil == 6) return "<font  style='color:var(--diary-sat);'>";
        if(yoil == 0) return "<font style='color:var(--diary-sun);'>";
        return "<font style='color:var(--diary-ink);'>";
    }

    var h = "";
    h += "<div id=\"mainHolder\">";
    h += "<table border=0 style=\"width:100%;\" class=\"noBdTb\"><tr><td style=\"border:none\">";
    h += "<div style=\"width:99%; text-align:center; margin:0px auto\">";
    h += "<table style=\"width:100%;table-layout:fixed; border-collapse:collapse; \" class=\"CCTable\">";

    h += "<thead><tr height='30'>";
    for(var i = 0; i < doms.length; i++){
        var fcc = "var(--diary-ink)";
        if(i == 0) fcc = "var(--diary-sun)";
        if(i == 6) fcc = "var(--diary-sat)";
        h += "<th align='center' style='padding:6;solid;width:30px;color:" + fcc + "'>" + doms[i] + "</th>";
    }
    h += "</tr></thead><tbody id='ccTbody'>";

    var nowDayCount = 1;
    var PreMin = 28;
    var CCT = 0;
    for(var rows = 0; rows < setRows; rows++){
        h += "<tr rowid='" + rows + "'>";
        CCT = 0;
        for(var cols = 0; cols < 7; cols++){
            var cellIndex = (7 * rows) + cols;
            var thisDay = "", FF = "", STT = "";
            if(startDay <= cellIndex && nowDayCount <= days){
                thisDay = year + "-" + pad2(month) + "-" + pad2(nowDayCount);
                STT = "OK";
                var yoil = new Date(year, month-1, nowDayCount).getDay();
                FF = getFFF(yoil) + nowDayCount + "</font>";
                nowDayCount++;
            } else if(cellIndex < startDay){
                var FX = PD - startDay + cellIndex + 1;        // 전달 꼬리
                thisDay = PY + "-" + PM + "-" + FX;
                if(FX < PreMin) PreMin = FX;
                FF = "<font style='color:var(--diary-text-dim);'>" + FX + "</font>";
                STT = " DIS";
            } else if(cellIndex >= days){
                CCT++;                                          // 다음달 머리
                thisDay = NY + "-" + NM + "-" + pad2(CCT);
                FF = "<font style='color:var(--diary-text-dim);'>" + CCT + "</font>";
                STT = " DIS";
            }
            var eaDiv = "";
            eaDiv += "<div class='inDivA " + STT + "' data-type='" + STT + "' id='inDiv1'><span class='inSpanAA A'>예</span><span class='inSpanAT'>0</span></div>";
            eaDiv += "<div class='inDivA " + STT + "' data-type='" + STT + "' id='inDiv2'><span class='inSpanAA B'>수</span><span class='inSpanAT'>0</span></div>";
            eaDiv += "<div class='inDivA " + STT + "' data-type='" + STT + "' id='inDiv3'><span class='inSpanAA C'>발</span><span class='inSpanAT'>0</span></div>";
            eaDiv += "<div  data-type='" + STT + "' id='inDiv4'><span></span><span class='inSpanAT right'>0</span></div>";
            var imons = (todayC == thisDay) ? " on" : "";
            var sttTrim = STT.replace(/^\s+|\s+$/g, "");
            var infoD = "<div style='width:100%;height:6px;clear:both'></div>";
            infoD += "<div class='tdInsideDiv' id='" + thisDay + "' data-type='" + sttTrim + "' style='visibility:hidden'>" + eaDiv + "</div>";
            if(diaryshowType != 1) infoD += "<div class='tdInsideDiv' id='" + thisDay + "_CM' data-type='" + sttTrim + "' style='display:none'></div>";
            var hrefV = "onclick=\"showDayInfo('" + thisDay + "'," + rows + ", this)\"";
            if(thisDay.length < 10) hrefV = "";
            var memoDiv = "<span class='memoCirdiv' style='display:none'></span>";
            h += "<td class='day_td" + imons + "' data-type='titleTD' id='TD_" + thisDay + "' " + hrefV + " ><b class='fw_bolder'>" + FF + "</b>" + memoDiv + infoD + "</td>";
        }
        h += "</tr><tr id='infoTake_" + rows + "' style='display:none; font-size:13px; text-align:center'><td colspan='7' style='border:none;overflow-x:hidden;'>" + rows + " 번째 날짜리스트 보이기</td></tr>";
    }
    h += "</tbody></table></div></td></tr></table>";

    var serMin = PY + "-" + PM + "-" + pad2(PreMin);
    var serMax = NY + "-" + NM + "-" + pad2(CCT);
    // (제거) #preBtn/#nxtBtn 히든 — 구 cmoveto onclick 공급 전용이었고 그 소비부가 제거됨

    h += "<input type=\"hidden\" id=\"PreMin\" value=\"" + PreMin + "\">";
    h += "<input type=\"hidden\" id=\"SerMin\" value=\"" + serMin + "\">";
    h += "<input type=\"hidden\" id=\"SerMax\" value=\"" + serMax + "\">";
    h += "<input type=\"hidden\" id=\"yearvalue\" value=\"" + year + "\">";
    h += "<input type=\"hidden\" id=\"monthvalue\" value=\"" + month + "\">";
    h += "</div>";

    return h;
}

// 달력그려주기 , 1) 달력껍데기는 클라이언트 생성, 2) 달력안에 데이터는 ajax 채우기
function year_month_apply(){
    var wYear = parseInt(document.getElementById("calender_yearval").value);
    var wMonth = parseInt(document.getElementById("calender_monthval").value);
    if( isNaN(wYear)) wYear = defYeaR;
    if( isNaN(wMonth)) wMonth = defMonth;
    isloadingClick = 0;
    // 달력 껍데기는 순수 날짜연산 → 서버왕복 없이 클라이언트에서 생성 (구 _sky_m_05_frame_ajax.php 대체)
    var obj = document.getElementById("cMainHolder");
    obj.innerHTML = buildCalendarShellHtml(wYear, wMonth, diaryshowType);
    obj.style.left="0px";
            // (제거) 숨은 레거시 상단바(cmoveto1/2 onclick, sery/serm/serym) write — 블록이 display:none 死였음
            var yy = parseInt(document.getElementById("yearvalue").value);
            var mm = parseInt(document.getElementById("monthvalue").value);
            document.getElementById("showDate_year").innerHTML = parseInt( yy-2000);
            document.getElementById("showDate_month").innerHTML = mm;

            document.getElementById("calender_yearval").value=yy;
            document.getElementById("calender_monthval").value=mm;
            var SerMin = document.getElementById("SerMin").value;
            var SerMax = document.getElementById("SerMax").value;
            var adr = "/m/ajax/diary/monthly/orders";
            var sendData = {"jobtype":"getcalender_searchdatas", "day_start":SerMin , "day_ends":SerMax , "ser_year":wYear ,"ser_month":wMonth}; //ser_year ser_month
            var ret = adr + "?jobtype=getcalender_searchdatas&day_start="+SerMin+"&day_ends="+SerMax +"&ser_year=" + wYear + "&ser_month=" + wMonth + "&istest=test";
            var date_range = SerMin.trim() + "-" + SerMax.trim();
            //console.log( ret );
            // var oneShow = 0;
            console.log( ret );
            if(month_GetHistory.indexOf(date_range) >= 0 ){
                get_firstDay_One();
                Show_Days_toEachTD();
            }else{
                // 달력 안의 데이터 채우는 ajax
                $.ajax({type:"get", url:adr , data:sendData , success:function(data){
                        draw_calendar_data(data, date_range);
                    }});
            }
    //document.location.href=
}

/**
 * 달력안에 예약,수주,발주,지출액 데이터를 채워준다.
 * @param data 오더 데이터
 * @param date_range 기간 ( 2022-10-28-2022-12-03 )
 */
function draw_calendar_data(data, date_range){
    var oneShow = 0;
    // var data = JSON.parse(data);
    month_GetHistory.push(date_range);
    var dataType = data.isSame;
    var chD = "";
    //console.log( data );
    var daYData = data.lists;
    var memocnt = data.memocnt;
    var VBtot = 0;
    var PayedB = 0;
    for (var i = 0;i < memocnt.length;i++ ){
        var nn = memocnt[i];
        var hd = nn[0];
        var vals = parseInt( nn[1]);
        if( isNaN(vals)) vals = 0;
        memo_cntList[hd] = vals;
    }
    for (var i = 0;i < daYData.length;i++ ){
        var workDay = daYData[i].work_day;
        if( workDay){
            var eaData = daYData[i];
            var order_type = eaData.order_type;
            var work_mode = eaData.work_mode;
            var expenses = parseInt(eaData.expenses);
            var car_price = parseInt(eaData.car_price);
            var order_status = parseInt(eaData.order_status);
            if( order_status != 99 ){ // 오더취소가 아닐때
                if( typeof(day_Values[workDay]) != "object") {
                    day_Values[workDay] = {};
                    day_Values[workDay]["date"] = workDay;
                    day_Values[workDay]["Bal"] = 0;
                    day_Values[workDay]["Soo"] = 0;
                    day_Values[workDay]["Soonums"] = "";
                    day_Values[workDay]["Balsign"] = 0;
                    day_Values[workDay]["Balsign_ok"] = 0;
                    day_Values[workDay]["Balsign_no"] = 0;
                    day_Values[workDay]["SooOK"] = 0;
                    day_Values[workDay]["SooNot"] = 0;
                    day_Values[workDay]["Reserv"] = 0;
                    day_Values[workDay]["expenses"] = 0;
                    day_Values[workDay]["Total"] = 0;
                    day_Values[workDay]["TotalBal"] = 0;
                    day_Values[workDay]["TotalBal_yet"] = 0;
                    day_Values[workDay]["Soo_yet"] = 0;
                    day_Values[workDay]["BalgetPayed"] = 0;
                    day_Values[workDay]["ineedtoGet"] = 0;
                    day_Values[workDay]["ialreadyGot"] = 0;
                    day_Values[workDay]["ialreadyPay"] = 0;
                    day_Values[workDay]["ineedtoPay"] = 0;
                    day_Values[workDay]["daymemo"] = 0;
                    day_Values[workDay]["BalNotPayed"] = 0;
                    day_Values[workDay]["taxbill_out_tot"] = 0;
                    day_Values[workDay]["taxbill_in_tot"] = 0;
                    day_Values[workDay]["datas"] = [];
                }

                if( chDate_in(day_Values[workDay]["datas"],  eaData.ordernum) == true ) {
                    day_Values[workDay]["datas"].push( eaData );
                    day_Values[workDay]["expenses"] = parseInt( day_Values[workDay]["expenses"] + expenses);
                    day_Values[workDay]["daymemo"] = eaData.daymemo;
                    if( parseInt( order_type) == 92 ){
                        day_Values[workDay]["Reserv"] = parseInt( day_Values[workDay]["Reserv"] + 1 );
                    }else{
                        var st = parseInt(eaData.order_status);
                        var worker_num = parseInt(eaData.worker_num);
                        var worker_owner_num = parseInt(eaData.worker_owner_num);
                        if( isNaN(worker_num)) worker_num = 0;
                        if( isNaN(worker_owner_num)) worker_owner_num = 0;
                        if( isNaN(st)) st = 1;
                        var chBout = parseInt( eaData.taxbill_out);
                        if( isNaN(chBout)) chBout = 0;

                        var thisStinfo = workDay + "/" + work_mode + " / 오더타입:" + eaData.order_type + " / "  + eaData.order_status + " / " + eaData.site_address + " / " + eaData.bal_contract_pay + " | " ;
                        if(work_mode == "수주"){
                            if( oneShow == 0 ){
                                //console.log(eaData);
                                oneShow = 1;
                            }
                            if( chBout > 0 ){
                                day_Values[workDay]["taxbill_out_tot"] = parseInt( day_Values[workDay]["taxbill_out_tot"] + 1);
                            }
                            if( st < 8   ){
                                day_Values[workDay]["Soo_yet"] = parseInt( day_Values[workDay]["Soo_yet"] + 1);
                            }else{
                                day_Values[workDay]["Total"] = parseInt( day_Values[workDay]["Total"] + car_price);
                            }
                            if( eaData.order_status > 7 ) {
                                if( parseInt(eaData.is_paid )== 1  ) {
                                    day_Values[workDay]["ialreadyGot"] = parseInt( day_Values[workDay]["ialreadyGot"] + car_price);
                                    day_Values[workDay]["SooOK"] = parseInt( day_Values[workDay]["SooOK"] + 1);

                                }else{
                                    day_Values[workDay]["ineedtoGet"] = parseInt( day_Values[workDay]["ineedtoGet"] + car_price);
                                    day_Values[workDay]["SooNot"] = parseInt( day_Values[workDay]["SooNot"] + 1);
                                }
                            }
                            day_Values[workDay]["Soo"] = parseInt( day_Values[workDay]["Soo"] + 1 );
                            day_Values[workDay]["Soonums"] = day_Values[workDay]["Soonums"] + "," +  eaData.ordernum;
                        }else if(work_mode == "발주"){
                            var chBout = parseInt( eaData.taxbill_got);
                            if( isNaN(chBout)) chBout = 0;
                            var bal_bill_issued = parseInt( eaData.bal_bill_issued);

                            if( chBout > 0 ) day_Values[workDay]["taxbill_in_tot"] = parseInt( day_Values[workDay]["taxbill_in_tot"] + 1);
                            if( st < 8   ) day_Values[workDay]["TotalBal_yet"] = parseInt( day_Values[workDay]["TotalBal_yet"] + 1);
                            ////  /임의발주 91 / 예약 92 /  교환 93 //  지정발주 95 /

                            if( parseInt(eaData.pay_method) == 1){
                                chBout = parseInt( eaData.taxbill_out_bal);
                                if( isNaN(chBout)) chBout = 0;
                                //bal_contract_pay soo_contract_pay
                                if( bal_bill_issued == 1 ) chBout = 1;
                                if( eaData.order_status > 7 && dir_Showmode == 2) {
                                    day_Values[workDay]["Soo"] = parseInt( day_Values[workDay]["Soo"] + 1 );
                                }

                                if( chBout > 0 ){
                                    day_Values[workDay]["taxbill_out_tot"] = parseInt( day_Values[workDay]["taxbill_out_tot"] + 1);
                                }
                                if( eaData.bal_contract_pay  == "거래처입금" ) {
                                    day_Values[workDay]["ialreadyGot"] = parseInt( day_Values[workDay]["ialreadyGot"] + car_price);
                                    day_Values[workDay]["SooOK"] = parseInt( day_Values[workDay]["SooOK"] + 1);
                                }else{
                                    day_Values[workDay]["ineedtoGet"] = parseInt( day_Values[workDay]["ineedtoGet"] + car_price);
                                    day_Values[workDay]["SooNot"] = parseInt( day_Values[workDay]["SooNot"] + 1);
                                }

                                day_Values[workDay]["Balsign"] = parseInt( day_Values[workDay]["Balsign"] + 1);
                                day_Values[workDay]["TotalBal"] = parseInt( day_Values[workDay]["TotalBal"] + car_price);
                                if( parseInt(eaData.is_paid )== 1 ) {
                                    day_Values[workDay]["ialreadyPay"] = parseInt( day_Values[workDay]["ialreadyPay"] + car_price);
                                    day_Values[workDay]["Balsign_ok"] = parseInt( day_Values[workDay]["Balsign_ok"] + 1);
                                }else{
                                    day_Values[workDay]["ineedtoPay"] = parseInt( day_Values[workDay]["ineedtoPay"] + car_price);
                                    day_Values[workDay]["Balsign_no"] = parseInt( day_Values[workDay]["Balsign_no"] + 1);
                                    PayedB = parseInt( PayedB + car_price);


                                }
                                VBtot = parseInt( VBtot + car_price );
                                if( eaData.geracherIn == "거래처입금"){
                                    day_Values[workDay]["BalgetPayed"] = parseInt( day_Values[workDay]["BalgetPayed"] + car_price);
                                }else{
                                    day_Values[workDay]["BalNotPayed"] = parseInt( day_Values[workDay]["BalNotPayed"] + car_price);
                                }
                            }
                            day_Values[workDay]["Bal"] = parseInt( day_Values[workDay]["Bal"] + 1 );
                        }
                    }
                }
            }
        }
    }
    get_firstDay_One();// 이건 머하는건지 잘 모르겠네...
    Show_Days_toEachTD();
    if( window.autoOnceDone == 3 && autoSelDate.length ==10 ){
        window.autoOnceDone = 2;
        find_dateOne_toLoad(autoSelDate);
    }
}


function get_firstDay_One(){
    var obj = document.getElementById("ccTbody");
    var inputs = obj.getElementsByTagName("DIV");
    var mm = Util.number_to_withzero(document.getElementById("calender_monthval").value,2);
    var thisYM = document.getElementById("calender_yearval").value + "-" + mm + "-01";
    if( fixed_yearMonth == document.getElementById("calender_yearval").value + "-" + mm ) thisYM = fixed_today;
    for (var i=0; i < inputs.length ; i++ ){
        if ( inputs[i].className == "tdInsideDiv"){
            var tar = inputs[i];
            var eaid = inputs[i].id;
            if( eaid == thisYM ){
                if( window.onceSelect < 1  && window.start_baseDate == "") {
                    window.start_baseDate = eaid;
                    baseMatchNode = inputs[i];
                }
            }
        }
    }

}
function chDate_in(aList, anum){
    if( aList.length < 1 ) return true;
    var OK = true;
    for (var i = 0; i < aList.length; i++){
        var chit = aList[i];
        if( parseInt(chit.ordernum) == parseInt(anum)){
            OK = false;
            break;
        }
    }
    return OK;

}
function DateChangeToCh(n){
    var Y = parseInt(document.getElementById("calender_yearval").value);
    var M = parseInt(document.getElementById("calender_monthval").value);
    if( n < 0 ){
        if( M == 1 ){
            Y = parseInt(Y-1);
            M = 12;
        }else{
            M = parseInt(M - 1);
        }
    }else{
        if( M == 12 ){
            Y = parseInt( Y+1);
            M = parseInt(1);
        }else{
            M = parseInt(M+1);
        }
    }
    DateChangeTo(Y,M);
}
function DateChangeTo(yy,mm){
    document.getElementById("calender_yearval").value=yy;
    document.getElementById("calender_monthval").value=mm;
    window.onceSelect = 0 ;
    window.lastCallShowDay = "";
    window.start_baseDate = "";
    year_month_apply();
}
// clear_ulsNode 제거 — 구 년월 오버레이(#YearMonthSelcter) 전용 UL 하이라이트 함수, 오버레이 삭제로 死코드화.

// function makeShowData(data){
//     var wYear = parseInt(document.getElementById("calender_yearval").value);
//     var wMonth = parseInt(document.getElementById("calender_monthval").value);
//     if( isNaN(wYear)) wYear = defYeaR;
//     if( isNaN(wMonth)) wMonth = defMonth;
//     var obj = document.getElementById("cMainHolder");
//     obj.innerHTML = data;
//     obj.style.left="0px";
//     var obj1 = document.getElementById("cmoveto1");
//     var obj2 = document.getElementById("cmoveto2");
//     obj1.setAttribute("onclick", document.getElementById("preBtn").value);
//     obj2.setAttribute("onclick", document.getElementById("nxtBtn").value);
//     var yy = parseInt(document.getElementById("yearvalue").value);
//     var mm = parseInt(document.getElementById("monthvalue").value);
//     document.getElementById("sery").value= yy + "년";
//     document.getElementById("serm").value=mm + "월";
//
//     var tar = document.getElementById("year_SelectUL");
//     clear_ulsNode(tar, yy, "selyear");
//     document.getElementById("calender_yearval").value=yy;
//     var tar = document.getElementById("month_SelectUL");
//     clear_ulsNode(tar, mm,"selmonth");
//     document.getElementById("calender_monthval").value=mm;
//     var SerMin = document.getElementById("SerMin").value;
//     var SerMax = document.getElementById("SerMax").value;
//     var adr = "/m/ajax/diary/monthly/orders";
//     var ret = adr + "?jobtype=getcalender_searchdatas&day_start="+SerMin+"&day_ends="+SerMax +"&ser_year=" + wYear + "&ser_month=" + wMonth + "&getmode=iframe";
//     var Hd = SerMin.trim() + "-" + SerMax.trim();
//     console.log( ret );
//     document.getElementById("get_dataframe").src=ret;
// }
function monthDataDisplayTo(data){
    var SerMin = document.getElementById("SerMin").value;
    var SerMax = document.getElementById("SerMax").value;
    var Hd = SerMin.trim() + "-" + SerMax.trim();
    var data = JSON.parse(data);
    month_GetHistory.push(Hd);
    var chD = "";
    var daYData = data.lists;
    var memocnt = data.memocnt;
    var VBtot = 0;
    var PayedB = 0;
    for (var i = 0;i < memocnt.length;i++ ){
        var nn = memocnt[i];
        var hd = nn[0];
        var vals = parseInt( nn[1]);
        if( isNaN(vals)) vals = 0;
        memo_cntList[hd] = vals;
    }
    for (var i = 0;i < daYData.length;i++ ){
        var workDay = daYData[i].work_day;
        var workDay = daYData[i].work_day;
        if( workDay){
            var eaData = daYData[i];
            var order_type = eaData.order_type;
            var work_mode = eaData.work_mode;
            var expenses = parseInt(eaData.expenses);
            var car_price = parseInt(eaData.car_price);
            var order_status = parseInt(eaData.order_status);
            if( order_status != 99 ){
                if( typeof(day_Values[workDay]) != "object") {
                    day_Values[workDay] = {};
                    day_Values[workDay]["Bal"] = 0;
                    day_Values[workDay]["Soo"] = 0;
                    day_Values[workDay]["Reserv"] = 0;
                    day_Values[workDay]["expenses"] = 0;
                    day_Values[workDay]["Total"] = 0;
                    day_Values[workDay]["TotalBal"] = 0;
                    day_Values[workDay]["TotalBal_yet"] = 0;
                    day_Values[workDay]["Soo_yet"] = 0;
                    day_Values[workDay]["BalgetPayed"] = 0;
                    day_Values[workDay]["ineedtoGet"] = 0;
                    day_Values[workDay]["ialreadyGot"] = 0;
                    day_Values[workDay]["ialreadyPay"] = 0;
                    day_Values[workDay]["ineedtoPay"] = 0;
                    day_Values[workDay]["daymemo"] = 0;
                    day_Values[workDay]["BalNotPayed"] = 0;

                    day_Values[workDay]["datas"] = [];
                }
                if(workDay == "2019-03-26"){
                }
                if( chDate_in(day_Values[workDay]["datas"],  eaData.ordernum) == true ) {
                    day_Values[workDay]["datas"].push( eaData );
                    day_Values[workDay]["expenses"] = parseInt( day_Values[workDay]["expenses"] + expenses);
                    day_Values[workDay]["daymemo"] = eaData.daymemo;
                    if( parseInt( order_type) == 92 ){
                        day_Values[workDay]["Reserv"] = parseInt( day_Values[workDay]["Reserv"] + 1 );
                    }else{
                        var st = parseInt(eaData.order_status);
                        var worker_num = parseInt(eaData.worker_num);
                        var worker_owner_num = parseInt(eaData.worker_owner_num);
                        if( isNaN(worker_num)) worker_num = 0;
                        if( isNaN(worker_owner_num)) worker_owner_num = 0;
                        if( isNaN(st)) st = 1;
                        if(work_mode == "수주"){
                            if( st < 8   ){
                                day_Values[workDay]["Soo_yet"] = parseInt( day_Values[workDay]["Soo_yet"] + 1);
                            }else{
                                day_Values[workDay]["Total"] = parseInt( day_Values[workDay]["Total"] + car_price);
                            }
                            if( parseInt(eaData.is_paid )== 1 ) {
                                day_Values[workDay]["ialreadyGot"] = parseInt( day_Values[workDay]["ialreadyGot"] + car_price);
                            }else{
                                day_Values[workDay]["ineedtoGet"] = parseInt( day_Values[workDay]["ineedtoGet"] + car_price);
                            }
                            day_Values[workDay]["Soo"] = parseInt( day_Values[workDay]["Soo"] + 1 );
                        }else if(work_mode == "발주"){

                            if( st < 8   ){ // TotalBal_yet  Soo_yet //&& ( worker_num > 0 || worker_owner_num > 0 )
                                day_Values[workDay]["TotalBal_yet"] = parseInt( day_Values[workDay]["TotalBal_yet"] + 1);
                            }
                            ////  /임의발주 91 / 예약 92 /  교환 93 //  지정발주 95 /
                            if( parseInt(eaData.pay_method) == 1){
                                if( eaData.order_type == "93" && st < 6 ){
                                }else{
                                    day_Values[workDay]["TotalBal"] = parseInt( day_Values[workDay]["TotalBal"] + car_price);
                                    if( parseInt(eaData.is_paid )== 1 ) {
                                        day_Values[workDay]["ialreadyPay"] = parseInt( day_Values[workDay]["ialreadyPay"] + car_price);
                                    }else{
                                        day_Values[workDay]["ineedtoPay"] = parseInt( day_Values[workDay]["ineedtoPay"] + car_price);
                                        PayedB = parseInt( PayedB + car_price);
                                    }
                                    VBtot = parseInt( VBtot + car_price );
                                    if( eaData.geracherIn == "거래처입금"){
                                        day_Values[workDay]["BalgetPayed"] = parseInt( day_Values[workDay]["BalgetPayed"] + car_price);
                                    }
                                }
                            }
                            day_Values[workDay]["Bal"] = parseInt( day_Values[workDay]["Bal"] + 1 );
                        }
                    }
                }
            }
        }
    }
    get_firstDay_One();
    Show_Days_toEachTD();
    if( window.autoOnceDone == 3 && autoSelDate.length ==10 ){
        window.autoOnceDone = 2;
        find_dateOne_toLoad(autoSelDate);
    }

}

// 현재 년월(calender_yearval/monthval) 기준으로 달력을 렌더한다 = 페이지 최초 렌더. (구 initPg)
function renderCalendarMonth(){
    year_month_apply();
}
function min_morefile(act,n){
    if( act == -1 && n == 1 ) return;
    if( act == 1 && n == 10 ){alert("최대 10장까지 전송할 수 있습니다.");return;}
    if( act == -1){
        var ss = parseInt( n,10);
        if (isNaN(ss)) ss = 0;
        if( ss < 2 ) return;
        var obj = document.getElementById("filegroupbox_" + ss);
        if(obj){
            obj.style.display="none";
            document.getElementById("uploadedfn_thumb" + ss).value="";
            document.getElementById("uploadedfn" + ss).value="";
            document.getElementById("showImage" + ss).value="";
        }
    }else{
        var ss = parseInt(n+1,10);
        if (isNaN(ss)) ss = 0;
        if( ss < 2 || ss > 10 ) return;
        var obj = document.getElementById("filegroupbox_" + ss);
        if(obj){
            obj.style.display="block";
            document.getElementById("uploadedfn_thumb" + ss).value="";
            document.getElementById("uploadedfn" + ss).value="";
            document.getElementById("showImage" + ss).value="";
        }
    }
}
